import styled from 'styled-components';
import { FlexColumn } from '@ubeya/shared-web/components';
import { media } from '@ubeya/shared-web/style';

export const AccordionContent = styled(FlexColumn)`
  width: 100%;
  padding: 24px 0 0 0;

  .fields-container:not(:empty) {
    margin-bottom: 24px;
  }
`;

export const RootWrapper = styled(FlexColumn)`
  position: relative;
  flex: 2;
  ${media.tablet`overflow: auto;`}
`;

export const RootContainer = styled.div`
  padding: 32px 30px;
  ${media.tablet`padding: 0 41px 40px`};

  ${({ isLoading }) => isLoading && 'opacity: 0.4;'}

  > div {
    margin-bottom: 24px;
  }
`;
